import { memo, useMemo } from "react"
import { ReportOptions, useFormat } from "../../../../hooks/useFormat"

import './index.scss'
import Reports from "../.."
import { FORMAT_TYPE } from "../../../../data/variables"

type DynamicColumn = {
  value: number
  row: any
  options?: ReportOptions
  type?: 'year' | 'week' | 'month'
}

const NEXT_TYPE = {
  year: 'month',
  month: 'week',
  week: undefined
}

const DynamicColumn = memo(({ value, row, options = {}, type = 'year' }: DynamicColumn) => {
  const { formatFunction } = useFormat()

  const clickable = !!NEXT_TYPE[type]

  const change = useMemo(() => {
    if (!clickable) return {}

    return {
      isExpanded: true,
      expandElem: (
        <Reports
          dynamicType={NEXT_TYPE[type]}
          showHeader={false}
          dynamicParams={{ date: options.headerId, mobileids: row.mobileid }}
          fetchOnLoad={true}
          tableTitle={row.globalid}
        />
      )
    }
  }, [clickable, options, row])

  return (
    <div
      className={`PeriodColumn${clickable ? ' clickable' : ''}`}
      role="button"
      tabIndex={0}
      onClick={(e) => {
        e.stopPropagation()
        options?.changeRow(row._rowId, { ...change, _expandSignal: Date.now() })
      }}
    >
      {options.format === FORMAT_TYPE.NONE ? value : formatFunction(value, row, undefined, options.format)}
    </div>
  )
})

export default DynamicColumn
